<template>
  <div class="component-wrapper d-flex flex-column secondary pt-2 px-8">
    <div
      :style="
        insets && insets.top > 0
          ? `margin-top: calc(${insets.top}px + 8px)`
          : 'margin-top: 8px'
      "
      class="primary rounded-pill pr-2 d-flex align-center justify-start mb-10"
      style="width: fit-content"
      @click="$router.go(-1)"
    >
      <v-btn icon v-if="$route.path.split('/')[1] != 'pois'">
        <v-icon color="white" size="17">mdi-arrow-left</v-icon>
      </v-btn>
      <span
        v-if="$route.path.split('/')[1] != 'pois'"
        class="body-2 white--text pr-1"
      >
        {{ $t("info_settings.back") }}
      </span>
    </div>

    <span
      text
      class="white--text text flex-grow-0 mb-4 text-uppercase"
      style="font-size: 16px; font-weight: bold"
    >
      {{ $t("info_settings.about") }}
    </span>

    <div class="d-flex flex-column justify-start">
      <div
        class="d-flex align-center justify-start"
        style="width: 100%"
        v-for="(item, i) in info_menu"
        :key="i"
      >
        <v-btn
          v-if="item.type == 'link'"
          color="white"
          text
          style="text-transform: none; width: 100%; text-align: start"
          @click="openBrowser(item)"
          class="pa-0 mb-2 d-flex justify-start"
        >
          <span class="">
            {{ item.text }}
          </span>
        </v-btn>
        <v-btn
          v-if="item.type == 'route'"
          color="white"
          text
          style="text-transform: none; min-width: 0; width: 100%"
          :to="item.path"
          class="pa-0 mb-2 d-flex justify-start"
        >
          <span class="pa-0 ma-0">
            {{ item.text }}
          </span>
        </v-btn>
        <span v-if="item.type == 'email'" class="white--text body-1">
          {{ item.text }}
        </span>
      </div>
    </div>

    <v-divider style="width: 100% !important" class="my-8"></v-divider>

    <span
      text
      class="white--text text flex-grow-0 mb-6 text-uppercase"
      style="font-size: 16px; font-weight: bold"
    >
      {{ $t("info_settings.settings") }}
    </span>

    <v-bottom-sheet
      v-model="dialog"
      inset
      style="position: relative"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="d-flex flex-column align-start mb-2"
        >
          <span text class="white--text text flex-grow-0">{{
            $t("info_settings.language")
          }}</span>
          <span v-if="language != null" class="body-2 grey--text">{{
            language.name
          }}</span>
        </div>
      </template>
      <v-card color="white" height="360px" class="px-6">
        <div class="text-h5 font-weight-bold pt-6">
          {{ $t("info_settings.choose-language") }}
        </div>
        <v-divider class="my-4"></v-divider>
        <div
          v-for="(lang, i) in languages"
          :key="i + lang.code"
          @click="componentLang = lang"
          class="mb-4"
        >
          <span
            :class="
              lang.code == componentLang.code
                ? 'font-weight-bold'
                : 'font-weight-regular'
            "
            class="body-1 d-flex align-center"
          >
            <span class="mr-auto">
              {{ lang.name }}
            </span>
            <img
              v-if="lang.code == componentLang.code"
              class="check-icon"
              src="@/assets/icons/check.png"
            />
          </span>
        </div>
      </v-card>
    </v-bottom-sheet>

    <div class="d-flex align-center mt-4">
      <span text class="white--text text mr-4">{{ tts_label }}</span>
      <v-switch
        v-model="autoPlayTTS"
        hide-details=""
        color="white"
        class="pa-0 ma-0"
      ></v-switch>
    </div>
  </div>
</template>

<script>
import { Browser } from "@capacitor/browser";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
    };
  },

  created() {},

  computed: {
    info_menu() {
      return [
        {
          text: this.$t("info_settings.about_app"),
          type: "route",
          path: "/settings/about",
        },

        {
          text: this.$t("info_settings.terms"),
          type: "route",
          path: "/settings/terms_and_policies",
        },

        {
          text: "Δήμος Νάξου",
          type: "link",
          path: "https://e-naxos.eu/",
        },

        {
          text: "e-Naxios.com",
          type: "link",
          path: "https://e-naxios.com/",
        },

        {
          text: "naxos@naxos.gov.gr",
          type: "email",
          path: "",
        },
      ];
    },

    tts_label() {
      return this.$t("info_settings.tts");
    },

    ...mapState({
      languages: (state) => state.base.languages,
      language: (state) => state.base.mobileLang,
      insets: (state) => state.base.insets,
    }),

    componentLang: {
      get() {
        return this.language;
      },
      set(newValue) {
        this.changeLang(newValue);
      },
    },

    autoPlayTTS: {
      get() {
        return this.$store.state.base.autoPlayTTS;
      },
      set(newValue) {
        this.setAutoPlayTTS(newValue);
      },
    },
  },

  methods: {
    ...mapMutations(["setMobileLang", "setAutoPlayTTS"]),
    ...mapActions(["getCategories", "isLanguageSupported"]),

    async openBrowser(item) {
      await Browser.open({ url: item.path });
    },

    async changeLang(lang) {
      this.setMobileLang(lang);
      this.$i18n.locale = this.language.code;
      await this.getCategories();
      await this.isLanguageSupported();
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.check-icon {
  width: 19px;
  height: 14px;
}
</style>